import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';
import buildPath from '@/tsClient/utilities/buildPath';

const PATH_TEMPLATE = '/my/completed';
type THIS_API = ApiDefinition[typeof PATH_TEMPLATE]['POST'];
type Input = THIS_API['body'];
type Output = THIS_API['response'];

const postCompleted = async (data: Input): Promise<Output> => {
  const path = buildPath<THIS_API>(PATH_TEMPLATE);
  const response = await noodleApiClient.post(path, data);
  return response.data;
};

export default postCompleted;
